import { type UseQueryResult, useQuery } from 'react-query';
import {
  VendorCompanyService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CompanyListDto,
} from '../../services/wealthlane-customer-services';
import { CustomTableInfoType } from '../../pages/vendor_customer';
import { TableParams } from '../../types/common';

const useGetCustomerListData = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CompanyListDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    fromOnboardedDate,
    toOnboardedDate,
    statusIds,
    _force,
  } = tableInfo;

  const customerListData = useQuery(
    [
      'getCustomerList',
      filter,
      sorting,
      skipCount,
      maxResultCount,
      fromOnboardedDate,
      toOnboardedDate,
      statusIds,
      _force,
    ],
    async () => {
      return await handleRequest(
        VendorCompanyService.getApiCustomerApiAppVendorCompany(
          fromOnboardedDate,
          toOnboardedDate,
          statusIds,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return customerListData;
};

export default useGetCustomerListData;
